import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDWfDc8cbqIAL36n0nSZqalStsprMO4hqc",
  authDomain: "convisas-net.firebaseapp.com",
  projectId: "convisas-net",
  storageBucket: "convisas-net.firebasestorage.app",
  messagingSenderId: "454153254949",
  appId: "1:454153254949:web:713b3362179d4296eee7cc",
};

const appService = initializeApp(firebaseConfig, "service");

const authService = getAuth(appService);
const firestoreService = getFirestore(appService);
const storageService = getStorage(appService);

export { authService, firestoreService, storageService };
